import { logEvent } from 'firebase/analytics';
import { analytics } from '../../config/firebaseConfig';

export const trackEvent = (eventName: string, parameters?: Record<string, any>) => {
	if (analytics) {
        console.debug(`Tracking event: ${eventName}`, parameters || {});
		logEvent(analytics, eventName, parameters);
	}
};

export const trackScreenView = (screenName: string) => {
	trackEvent('screen_view', { screen_name: screenName });
};

export const trackTiming = (name: string, value: number, category?: string) => {
	trackEvent('timing_complete', {
		name,
		value,
		event_category: category || 'engagement'
	});
};